import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const flexStyles = makeStyles({
	flexContainer: {
		display: 'flex',
	},
	flexDirectionRow: {
		flexDirection: 'row',
	},
	flexDirectionColumn: {
		flexDirection: 'column',
	},
	flexNoWrap: {
		flexWrap: 'nowrap',
	},
	flexJustifyCenter: {
		justifyContent: 'center',
	},
	flextJustifyEnd: {
		justifyContent: 'flex-end',
	},
	flexSpaceAround: {
		justifyContent: 'space-around',
	},
	flexSpaceBetween: {
		justifyContent: 'space-between',
	},
	flexAlignItemsCenter: {
		alignItems: 'center',
	},
	flexAlignItemsStart: {
		alignItems: 'flex-start',
	},
	flexGow1: {
		flexGrow: 1,
	},
});

/**
 * @property ClassName_None 0px
 * @property ClassName_XXS 2px
 * @property ClassName_XS 4px
 * @property ClassName_SNudge 6px
 * @property ClassName_S 8px
 * @property ClassName_MNudge 10x
 * @property ClassName_M 12px
 * @property ClassName_L 16px
 * @property ClassName_XL 20px
 * @property ClassName_XXL 24px
 * @property ClassName_XXXL 32px
 */
const spacingStyles = makeStyles({
	marginBottomM: {
		marginBottom: tokens.spacingVerticalM,
	},
	marginBottomS: {
		marginBottom: tokens.spacingVerticalS,
	},
	marginHorizontalS: {
		...shorthands.margin(0, tokens.spacingHorizontalS),
	},
	height100: {
		height: '100%',
	},
	padding16: {
		...shorthands.padding('16px'),
	},
	commonWhiteBackground: {
		backgroundColor: tokens.colorNeutralBackground1,
	},
	overflowAuto: {
		...shorthands.overflow('auto'),
	},
});

const commonStyle = { flexStyles, spacingStyles };

export default commonStyle;
